import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqs } from '../data/mock';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  const { t } = useTranslation('landing');
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-24 bg-[#0a0a0b]">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            {t('faq.headline')}
          </h2>
          <p className="text-xl text-gray-400 mt-4">{t('faq.subtitle')}</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-800 rounded-xl overflow-hidden hover:border-amber-500/30 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors"
              >
                <span className="text-white font-medium pr-4">{t(`faq.items.${faq.key}.q`)}</span>
                <ChevronDown
                  className={`w-5 h-5 text-amber-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 text-gray-400 leading-relaxed">
                  {t(`faq.items.${faq.key}.a`)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
